var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"responsive-image"},[_c('img',_vm._b({},'img',_vm.imageOptions,false))])
}
var staticRenderFns = []

export { render, staticRenderFns }